import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MarketingPage from './marketing/MarketingPage';
import PrivacyPolicy from './marketing/PrivacyPolicy';
import SmsTerms from './marketing/SmsTerms';

function App() {
  useEffect(() => {
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    document.head.appendChild(preconnect1);

    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect2);

    const fontsLink = document.createElement('link');
    fontsLink.rel = 'stylesheet';
    fontsLink.href =
      'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Manrope:wght@300;400;500;600;700&family=Oswald:wght@300;400;500;600&display=swap';
    document.head.appendChild(fontsLink);

    document.title = 'Black-Ops Luxury Car Service — Discretion · Excellence · Arrival';

    return () => {
      [preconnect1, preconnect2, fontsLink].forEach((el) => el.parentNode && el.parentNode.removeChild(el));
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/sms-terms" element={<SmsTerms />} />
        <Route path="*" element={<MarketingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
